import React from 'react';
import { Checkbox, Tooltip } from 'components';
import classNames from 'classnames';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import styles from '../fleet-rule.module.scss';

interface CheckboxAttributeProps {
	title: string;
	tooltipText: string;
	onChangeCheckbox: (e) => void;
	checked?: boolean;
	disabled?: boolean;
}

export const CheckboxAttribute = ({
	onChangeCheckbox,
	tooltipText,
	title,
	checked = false,
	disabled = false
}: CheckboxAttributeProps) => {
	return (
		<>
			<div data-test-id="fleet-router-rule-body-left-side-checkbox" className={styles['checkbox-attribute']}>
				<Checkbox onChange={onChangeCheckbox} checked={checked} disabled={disabled} />
				<span
					className={classNames(styles['checkbox-attribute-text'], {
						[styles['disabled']]: disabled
					})}
				>
					{title}
					<Tooltip placement="top" title={tooltipText}>
						<span className={styles['info-button']}>
							<BringgIcon iconName={BringgFontIcons.Info} />
						</span>
					</Tooltip>
				</span>
			</div>
		</>
	);
};
